import Flickity from 'flickity'

const imagesLoaded = require('imagesloaded')

const createSlider = (el, params) => {
  const sliderEl = el.querySelector('[data-slider-slides]')
  const prevButtons = el.querySelectorAll('[data-slider-button="prev"]')
  const nextButtons = el.querySelectorAll('[data-slider-button="next"]')
  const currentIndexEls = el.querySelectorAll('[data-slider-current]')
  const lastIndexEls = el.querySelectorAll('[data-slider-last]')

  const goNext = () => {
    flkty.next()
  }

  const goPrev = () => {
    flkty.previous()
  }

  const flktyOptions = Object.assign({}, params, {
    freeScroll: false,
    contain: true,
    percentPosition: false,
    prevNextButtons: false,
    pageDots: false,
    pauseAutoPlayOnHover: false,
    on: {
      deactivate () {
        if (prevButtons.length) {
          for (let i = 0; i < prevButtons.length; i++) {
            prevButtons[i].removeEventListener('click', goPrev)
          }
        }

        if (nextButtons.length) {
          for (let i = 0; i < nextButtons.length; i++) {
            nextButtons[i].removeEventListener('click', goNext)
          }
        }
      },
      select () {
        if (lastIndexEls.length) {
          const lastIndex = sliderEl.querySelectorAll('[data-slider-cell]').length
          const slidesCount = flkty ? flkty.slides.length : lastIndex

          for (let i = 0; i < lastIndexEls.length; i++) {
            lastIndexEls[i].innerHTML = slidesCount
          }

          if (currentIndexEls.length) {
            for (let i = 0; i < currentIndexEls.length; i++) {
              currentIndexEls[i].setAttribute('aria-label', `Last page index: ${slidesCount}`)
            }
          }
        }
      },
      ready () {
        if (prevButtons.length) {
          for (let i = 0; i < prevButtons.length; i++) {
            prevButtons[i].addEventListener('click', goPrev)
          }
        }

        if (nextButtons.length) {
          for (let i = 0; i < nextButtons.length; i++) {
            nextButtons[i].addEventListener('click', goNext)
          }
        }

        if (!params || !params.wrapAround) {
          if (prevButtons.length) {
            for (let i = 0; i < prevButtons.length; i++) {
              prevButtons[i].disabled = true
            }
          }
        }

        imagesLoaded(sliderEl, () => {
          flkty.resize()
        })
      }
    }
  })

  const flkty = new Flickity(sliderEl, flktyOptions)

  flkty.on('change', index => {
    if (currentIndexEls.length) {
      for (let i = 0; i < currentIndexEls.length; i++) {
        currentIndexEls[i].innerHTML = index + 1
      }
    }

    if (!params || !params.wrapAround) {
      if (prevButtons.length) {
        for (let i = 0; i < prevButtons.length; i++) {
          prevButtons[i].disabled = index === 0
        }
      }

      if (nextButtons.length) {
        for (let i = 0; i < nextButtons.length; i++) {
          nextButtons[i].disabled = index === flkty.slides.length - 1
        }
      }
    }
  })
}

export default createSlider
